import _ClaimGateSwal from 'sweetalert2'; // [2026-11-05] แจ้งเตือนเงื่อนไขยอดเงินรับกิจกรรม
import axios from 'axios';
import { attachLoader } from './siteLoader';
//require('dotenv').config({ path: `.env.${process.env.NODE_ENV}` })

var api_URL = 'http://localhost:7001'
if (process.env.NODE_ENV === "development") {
  api_URL = 'http://localhost:7001'
}
else if (process.env.NODE_ENV === "production") {
  api_URL = 'https://apiclient.newworld.center'
}
const instance = axios.create({
  baseURL: api_URL
});

// const instance = axios.create({
//     baseURL: 'http://localhost:7001'
// });
console.log(process.env.NODE_ENV);
const AUTH_TOKEN = "123"
const System = "Betner"
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

// [2026-10-25] หน้าโหลดโลโก้ตอนรอ API (src/siteLoader.js)
attachLoader(instance);

// [2026-11-05] เงื่อนไขยอดเงินรับกิจกรรม (BO › เงื่อนไขยอดเงินรับกิจกรรม): backend ตอบ status 208 + claimGate -> แจ้งเตือนลูกค้า
instance.interceptors.response.use((res) => {
  try {
    const d = res && res.data;
    if (d && d.claimGate && d.message) {
      _ClaimGateSwal.fire({ icon: 'warning', title: 'ยังรับกิจกรรมนี้ไม่ได้', text: d.message, confirmButtonText: 'ตกลง' });
    }
  } catch (e) { }
  return res;
});

export default instance;